<template>
  <ProfileChooseComponent v-if="profileChoose.show" :action="'switchAccount'" />
  <LoadingDialog :visible="loading" />
  <div>
    <nav
      class="webmenu-navbar fixed top-0 left-0 right-0 bottom-[calc(100vh-theme(spacing.16))] z-50 hidden md:flex justify-between items-center font-semibold bg-white py-5 px-4 lg:px-8 xl:px-12 text-oxford-blue">
      <RouterLink to="/" aria-label="Ir para a página inicial">
        <img src="../../public/img/jobifull-retangular.png" alt="logo jobifull" class="w-20 lg:w-32" />
      </RouterLink>

      <ul class="flex flex-col md:flex-row space-y-1 md:space-y-0 md:space-x-6 lg:space-x-7">
        <li>
          <RouterLink to="/">{{ translate('home', 'ucfirst') }}</RouterLink>
        </li>
        <li>
          <RouterLink to="/jobs">{{ translate('jobs', 'ucfirst') }}</RouterLink>
        </li>
        <li class="hidden" v-if="[undefined, null, 0].includes(env('APP_BETA'))">
          <RouterLink to="/applicants">{{ translate('professionals', 'ucfirst') }}</RouterLink>
        </li>
        <li>
          <RouterLink to="/companies">{{ translate('companies', 'ucfirst') }}</RouterLink>
        </li>
        <li class="hidden" v-if="[undefined, null, 0].includes(env('APP_BETA'))">
          <RouterLink to="/plans">{{ translate('plans', 'ucfirst') }}</RouterLink>
        </li>
      </ul>

      <div v-if="store.getters.isLoggedIn" class="flex items-center md:space-x-2">
        <span class="mr-2">
          <RouterLink v-if="user.userLogged && user.loggedAs !== 'professional'"
            :to="`/dashboard/${user.loggedAs}/${user.slug}/post-job`"
            class="flex items-center pl-1.5 pr-3 pt-1.5 pb-1.5 rounded-full text-white font-medium bg-sea-serpent">
            <i class="pi pi-plus bg-white rounded-full text-gray-500 p-1 text-sm mr-1"></i>
            <span class="text-sm text-white">{{ translate('Post job', 'ucfirst') }}</span>
          </RouterLink>
        </span>

        <i v-if="[undefined, null, 0].includes(env('APP_BETA'))" class="pi pi-bell mr-2"
          style="display:none;font-size: 1.5rem; color: #3c496c"></i>
        <ProfileAvatar
          :src="store.getters.getProfileImage" :alt="translate('profile photo', 'ucfirst')"
          class="rounded-full w-10 h-10" />
        <p>{{ store.getters.getNameByProfile }}</p>
        <Button type="button" :icon="`pi ${!toggleChevron ? 'pi-chevron-down' : 'pi-chevron-up'}`" @click="toggle"
          aria-haspopup="true" aria-controls="home_user_submenu" />
        <Menu ref="menu" id="home_user_submenu" :model="items" :popup="true">
          <template #item="{ item, props }">
            <div
              v-if="item.profile.includes(store.getters.getLoggedAs) && (item.display == undefined || item.display == true)">
              <RouterLink v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                <a v-ripple :href="href" v-bind="props.action" @click="navigate">
                  <span :class="item.icon" />
                  <span class="ml-2">{{ item.label }}</span>
                </a>
              </RouterLink>
              <a v-else v-ripple :href="item.url" :target="item.target" v-bind="props.action"
                @click.prevent="callMethod(item.action)">
                <span :class="item.icon" />
                <span class="ml-2">{{ item.label }}</span>
              </a>
            </div>
          </template>
        </Menu>
      </div>

      <div v-else class="flex items-center md:space-x-2">
        <span class="mr-3 font-medium text-oxford-blue">
          <RouterLink to="/login">
            {{ translate('enter', 'ucfirst') }} 
          </RouterLink>
          /
          <RouterLink to="/register">
            {{ translate('register', 'ucfirst') }}
          </RouterLink>
        </span>

         <RouterLink to="/login?r_post=1"
          class="flex items-center mr-4 pl-1.5 pr-3 pt-1.5 pb-1.5 rounded-full text-oxford-blue white font-medium bg-sea-serpent">
          <i class="pi pi-plus bg-white rounded-full p-1 text-sm mr-1.5"></i>
          <span class="4text-sm text-white font-medium">{{ translate('post job', 'ucfirst') }}</span>
        </RouterLink> 
      </div>
    </nav>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from "vue";
import { RouterLink } from "vue-router";
import ProfileAvatar from '@/components/Base/ProfileAvatar.vue';
import store from "@/store";
import Menu from "primevue/menu";
import Button from "primevue/button";
import authUser from "@/composables/authUser";
import { showToast } from "@/composables/toast";
import { useToast } from 'primevue/usetoast';
import requestHandler from "@/composables/requestHandler";
import LoadingDialog from "./Utils/LoadingDialog.vue";
import { translate } from "@/composables/translate";
import ProfileChooseComponent from "./ProfileChooseComponent.vue";
import { env } from "@/composables/config";

const toast = useToast();
const profileChoose = reactive({
  show: false,
  profileName: null
});

let user = reactive({
  username: computed(() => store.state.user.name),
  usertype: computed(() => store.state.user.userType),
  loggedAs: computed(() => store.state.user.loggedAs),
  slug: computed(() => store.state.user.slug),
  userLogged: computed(() => store.state.user.userLogged)
});


const loading = ref(false);
const toggleChevron = ref(false);
const menu = ref();

const redirectToRightProfile = (loggedAs ='') => {
  return loggedAs == 'professional' 
  ? `${store.getters.getLoggedAs}/${store.getters.getUserSlug}/preview/curriculum`
  : `${store.getters.getLoggedAs}/${store.getters.getUserSlug}`
};


const items = ref([
  {
    label: "",
    items: [
      {
        label: translate('dashboard', 'ucfirst'),
        icon: "pi pi-home",
        route: `/dashboard/${store.getters.getLoggedAs !== null 
        ? redirectToRightProfile(store.getters.getLoggedAs) 
        : 'profile'}`,
        profile: ['company', 'recruiter', 'professional', null]
      },
      {
        label: translate('publish job offer', 'ucfirst'),
        icon: "pi pi-file-edit",
        route: `/dashboard/${store.getters.getLoggedAs === null || store.getters.getLoggedAs == 'company' ? `company/${store.getters.getUserSlug}/post-job` 
        : store.getters.getLoggedAs == 'recruiter' 
        ? `recruiter/${store.getters.getUserSlug}/post-job` : 'profile'}`,
        profile: ['company','recruiter'] 
      }, 
      {
        label: translate('edit profile', 'ucfirst'),
        icon: "pi pi-user-edit",
        route: `/dashboard/${store.getters.getLoggedAs}/${store.getters.getUserSlug}/profile`,
        profile: ['company','recruiter','professional'],
        display: store.getters.isLoggedIn 
      },
      {
        label: translate('switch account', 'ucfirst'),
        icon: "pi pi-user-edit",
        action: 'switchAccount',
        profile: ['company', 'recruiter', 'professional'],
        display: store.getters.getLoggedUserNotLoggedInProfile.length > 1 ? true : false
      },
      {
        label: translate('end session'),
        icon: "pi pi-sign-out",
        name: "logout",
        action: 'logout',
        profile: ['company', 'recruiter', 'professional', null]
      },
    ],
  },
]);

const toggle = (event) => {
  toggleChevron.value = !toggleChevron.value;
  menu.value.toggle(event);
};

function callMethod(methodName = '') {
  switch (methodName) {
    case 'logout':
      logout();
      break;
    case 'switchAccount':
      switchAccount();
      break;
  }
}

async function logout() {
  loading.value = true;
  const response = await authUser.logout();
  if (!response['success']) {
    showToast(toast, response['message'], 'error');
  } else {
    store.dispatch('saveSessionMessage', { message: translate('logged out with success'), messageType: 'success' });
    requestHandler.redirect('/login');
  }
  loading.value = false;
}

async function switchAccount() {
  if (profileChoose.profileName == null) {
    profileChoose.show = true;
    return;
  }
  profileChoose.show = false;
  showToast(toast, translate('profile changed', 'ucfrist'));
}
</script>

<style scoped></style>
